<div [ngClass]=" !envelopeStructure.isList ? 'container-card' : ''">
	<cdx-card *ngFor="let envelope of envelopeStructure.list"
		[options]="envelope.cardOptions" [title]="envelope.title"
		(cardClick)="onCardClick($event, envelope)" (cardDblClick)="onCardDoubleClick(envelope)">
		<ng-container
			[ngTemplateOutlet]="envelopeStructure.isList ? listCardTemplate : gridCardTemplate"
			[ngTemplateOutletContext]="{envelope:envelope}">
		</ng-container>
	</cdx-card>
</div>

<ng-template #gridCardTemplate let-envelope='envelope'>
	<app-envelope-grid-card-content  [envelope]="envelope"
	(cardCheck)="onCardCheck(envelope)"></app-envelope-grid-card-content>
</ng-template>

<ng-template #listCardTemplate let-envelope='envelope'>
	<app-envelope-list-card-content [envelope]="envelope"></app-envelope-list-card-content>
</ng-template>
